import { DateUtilities } from '../services/date-utility.service';
import type { DeepLinkingParams } from './deep-linking.model';

export const PASS_PARAMS_DATE_INPUT_FORMAT: string = 'MMDDYYYY';
export const PASS_PARAMS_DATE_INPUT_REGEX: RegExp = /^[0-9]{8}$/;
export const PASS_PARAMS_DATE_OUTPUT_FORMAT: string = DateUtilities.defaultDateISOFormat;

export interface PassParamsMap {
  deepLinkingPassParams?: PassParams | null;
}

export class PassParams {
  ZipCode?: string;
  Zip?: string;
  CountyFips?: string;
  Fips?: string;
  PlanType?: string;
  PlanId?: string;
  Plan?: string;
  TFN?: string;

  static createFromDeepLinking(deepLinkingParams: DeepLinkingParams): PassParams | null {
    if (deepLinkingParams && Object.keys(deepLinkingParams).length) {
      const {
        ZIPCODE: ZipCode,
        ZIP: Zip,
        COUNTYFIPS: CountyFips,
        FIPS: Fips,
        PLANTYPE: PlanType,
        PLANID: PlanId,
        PLAN: Plan,
        TFN
      } = deepLinkingParams;

      return {
        ...(ZipCode && { ZipCode }),
        ...(Zip && { Zip }),
        ...(CountyFips && { CountyFips }),
        ...(Fips && { Fips }),
        ...(PlanType && { PlanType }),
        ...(PlanId && { PlanId }),
        ...(Plan && { Plan }),
        ...(TFN && { TFN })
      };
    }
    return null;
  }

  static mapToDeepLinkingParams(params: PassParams): DeepLinkingParams | null {
    if (params) {
      const {
        ZipCode: ZIPCODE,
        Zip: ZIP,
        CountyFips: COUNTYFIPS,
        Fips: FIPS,
        PlanType: PLANTYPE,
        PlanId: PLANID,
        Plan: PLAN,
        TFN
      } = params;

      return {
        ...(ZIPCODE && { ZIPCODE }),
        ...(ZIP && { ZIP }),
        ...(COUNTYFIPS && { COUNTYFIPS }),
        ...(FIPS && { FIPS }),
        ...(PLANTYPE && { PLANTYPE }),
        ...(PLANID && { PLANID }),
        ...(PLAN && { PLAN }),
        ...(TFN && { TFN })
      };
    }
    return null;
  }
}
